import React from "react";

const About = () => {
  return (
    <>
      <div id="phead">About:</div>
      <p style={{ margin: "1em", padding: "1em" }}>
        Bharath Engineering Services (BES) is a pioneer in material movement and
        in-campus electric mobility solutions, dedicated to innovation, thought
        leadership and quality. Our comprehensive range of material-handling
        equipment caters to efficiency in floor transportation, loading,
        unloading, stacking, towing, and hauling. Our state-of-the-art facility
        in Hyderabad leverages the best-in-class processes and technology,
        coming together to create smart and responsible solutions that cater to
        the needs of leading brands. Among the first few companies to introduce
        ‘total solutions’, our dedicated sales and service team works tirelessly
        to tailor solutions to the unique needs of each client, Sustainability
        lies at the heart of our product range; we have spearheaded the design
        and manufacturing of electric buggies that offer eco-friendly in-campus
        mobility across India. Experience the synergy of trust and product
        efficiency with Bharath Engineering Services 
      </p>
    </>
  );
};

export default About;
